


import { Component, Prop, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

import AnnouncementsComponent from './Announcements/Announcements.vue';
import NewsComponent from './News/News.vue';
import EventsComponent from './Events/Events.vue';

@Component({
    components: {
        EventsComponent,
        AnnouncementsComponent,
        NewsComponent
    },
    computed: {
        ...mapGetters(['config'])
    }
})
export default class SearchResultComponent extends Vue {
    @Prop() configRaw!: string;

    private loaded = false;
              
    mounted() {
        this.init();
    }

    private init(): void {
        this.isVisible();
        this.eventListeners();
    }

    private eventListeners() {
        window.addEventListener('resize', this.isVisible, true);
    }

    /**
     * Only render the data when the widget is visible.
     * We check if the Parent element is visible using offsetParent.
     * OffsetParent will return null when one of its parent elements is not visibile.
     */
    private isVisible(): void {
        if (this.$el.parentElement && this.$el.parentElement.offsetParent !== null && !this.loaded) {
            this.loaded = true;
            this.startup();
            removeEventListener('resize', this.isVisible, true);
        }
    }

    private startup(): void {
        try {
            this.$store.commit('setConfig', this.configRaw);
            this.$store.commit('setResultsPerPage', this.$store.getters.config.resultsPerPage);
            this.$store.commit('setCurrentPage', 0);
            this.$store.commit('setAzureSearch');
            this.$store.commit('setErrors', []);
            this.$store.dispatch('loadData', [false]);
        } catch (error) {
            this.$store.commit("setLoading", false);
        }
    }
}
